import React, { useEffect, useState } from "react";
import { Redirect, withRouter } from "react-router-dom";
import "./Login.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Spinner from "../Spinner/Spinner";
import { handleException } from "../../app/util/util";
import loaderColors1 from "../Spinner/loaderColors1.gif";
function Login() {
  console.log('login page')
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [userName, setUserName] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [loggedInFlag, setLoggedInFlag] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [sessionAuthToken, setSessionAuthToken] = useState("");
  useEffect(() => {
    document.title = "Sign in | Aspen Publishing";
    generateSessionAuthToken();
  }, []);
  function generateSessionAuthToken() {
    let reqData = {
      userVO: {
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
        },
      },
    };
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageUserService/generateSessionAuthenticationTokenForUnLoggedInUser`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === "true" && data.sessionAuthenticationToken) {
          setSessionAuthToken(data.sessionAuthenticationToken);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function validUserAuthentication() {
    var reqData = {
      userVO: {
        userRole: "",
        userRoleId: "",
        email: userName,
        linkFlag: false,
        password: btoa(userPassword),
        streamContentRequiredFlag: false,
        userActivityVO: {
          pageNavigatingTo: "",
          pageNavigatingFrom: "LOGIN",
          lastActivityCode: "BOOKSHELF",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          sessionAuthenticationToken: sessionAuthToken,
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
        },
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageUserService/userAuthentication`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          let userVO = data.userVO;
          if (userVO) {
            userVO.sessionAuthenticationToken = data.sessionAuthenticationToken;
            localStorage.setItem("userName", userVO.firstName);
            localStorage.setItem("userVO", JSON.stringify(userVO));
            localStorage.setItem(
              "apJwtAuthenticationToken",
              userVO.apJwtAuthenticationToken
                ? userVO.apJwtAuthenticationToken
                : "",
            );
            setLoggedInFlag(true);
            setSessionAuthToken(data.sessionAuthenticationToken);
          }
        } else if (
          data.httpErrorCode &&
          (data.httpErrorCode === "400" || data.httpErrorCode === "500")
        ) {
          let loginErrorMsg = "";
          if (data.wkErrorCode === "bus.exception.user.not.exists") {
            loginErrorMsg =
              "Error: Your email address or password is incorrect. Please try again.";
          } else if (
            data.wkErrorCode ===
            "bus.exception.username.and.password.did.not.match"
          ) {
            loginErrorMsg =
              "Error: Your email address or password is incorrect. Please try again.";
          } else if (
            data.wkErrorCode ===
              "bus.exception.this.is.not.an.activated.account" ||
            data.wkErrorCode ===
              "bus.exception.this.is.not.an.activated.aspenAccount"
          ) {
            loginErrorMsg =
              "Error: You have not verified your email address. Please check your inbox or SPAM folder and follow the " +
              "instructions, or <a href='#' id='login-click-here' className='resend-email-btn' rel='popover' data-toggle='popover'" +
              "data-html='true' data-container='body' data-action='/manageUserService/sendFirstTimelgPageLoginAcctivationEmail'" +
              "data - handler='activationEmail' title='click here'> click here </a>to send a new validation email.";
          } else {
            loginErrorMsg = data.errorMessg;
          }
          setErrorMsg(loginErrorMsg);
        }
        setIsLoginLoading(false);
      })
      .catch((error) => {
        setIsLoginLoading(false);
        setErrorMsg("Error: A system exception occurred. Please try again.");
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  const handleLoginInputKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLoginClick();
    }
  };
  const handleKeepMeLogin = () => {
    if (document.getElementById("keepMeLogId").checked) {
      localStorage.setItem("keepLoggedIn", "true");
    } else {
      localStorage.removeItem("keepLoggedIn");
    }
  };
  const handleLoginClick = () => {
    var emailVal = userName.trim(),
      passWordVal = userPassword.trim(),
      loginErrorMsg = "";
    const emailRegEx =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailVal === "" && passWordVal === "") {
      loginErrorMsg = "Error: All fields are required.";
    } else if (emailVal === "" && passWordVal !== "") {
      loginErrorMsg = "Error: Email is required.";
    } else if (emailVal !== "" && !emailRegEx.test(emailVal)) {
      loginErrorMsg =
        "Error: Your email address or password is incorrect. Please try again.";
    } else if (emailVal !== "" && passWordVal === "") {
      loginErrorMsg = "Error: Password is required.";
    } else {
      loginErrorMsg = "";
      setIsLoginLoading(true);
      validUserAuthentication();
    }
    setErrorMsg(loginErrorMsg);
  };
  return (
    <React.Fragment>
      <Spinner
        loading={isLoginLoading}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <div>
        <Header pageName="login" />
        {!loggedInFlag ? (
          <div className="row lgPageBackGr">
            <div className="col-xl-4 col-lg-4 col-sm-8 col-md-6 col-xs-12 mx-auto text-center lgPageBase">
              <div className="lgPageContainer no-padding">
                <form className="form">
                  <div className="lgPageLoginBackGr">
                    <div className="lgPageLoginDiv" role="main">
                      <h3 className="lgPageWelcomeMsg">Welcome back !</h3>
                      <p className="lgPageLoginAcc">Log in to your account</p>
                      <div
                        data-testid="lgPageErrMsg"
                        id="loginErrorMsg"
                        role="alert"
                        className="lgPageErrMsg"
                      >
                        {errorMsg}
                      </div>
                      <label
                        htmlFor="login_email"
                        id="LabelEmail"
                        className="lgPageEmailLabel"
                      >
                        Email Address
                      </label>
                      <input
                        data-testid="login_email"
                        type="text"
                        name="userName"
                        aria-label="Enter email address"
                        aria-describedby={
                          errorMsg ? "loginErrorMsg" : undefined
                        }
                        aria-invalid={errorMsg ? "true" : undefined}
                        id="login_email"
                        value={userName}
                        className="lgPageTxtBox form-control"
                        autoComplete=""
                        onKeyPress={handleLoginInputKeyPress}
                        onChange={(e) => setUserName(e.target.value)}
                      />
                      <label
                        htmlFor="login_password"
                        id="LabelPwd"
                        className="lgPagePwdLabel"
                      >
                        Password
                      </label>
                      <input
                        data-testid="login_password"
                        type="password"
                        name="password"
                        aria-label="Enter password"
                        aria-describedby={
                          errorMsg ? "loginErrorMsg" : undefined
                        }
                        aria-invalid={errorMsg ? "true" : undefined}
                        id="login_password"
                        value={userPassword}
                        className="lgPageTxtBox form-control"
                        autoComplete="new-password"
                        onKeyPress={handleLoginInputKeyPress}
                        onChange={(e) => setUserPassword(e.target.value)}
                      />
                      <div className="">
                        <label>
                          <input
                            data-testid="keepMeLogId"
                            type="checkbox"
                            id="keepMeLogId"
                            className="lgPageCheckBox"
                            onChange={handleKeepMeLogin}
                          />
                          <span className="lgPageCheckBoxTxt">
                            Keep me logged in
                          </span>
                        </label>
                        <span className="pull-right lgPageForPwdTxt">
                          Forgot password?
                        </span>
                      </div>
                      <div className="lgPageBtnSect">
                        <button
                          data-testid="login_submit"
                          type="button"
                          className="lgPageBtn"
                          onClick={handleLoginClick}
                          title="Login"
                        >
                          Log In
                        </button>
                        <span className="pull-right lgPageFirstUser">
                          First time user?
                        </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : null}
        {loggedInFlag || JSON.parse(localStorage.getItem("userVO")) !== null ? (
          <Redirect to="/dashboard" />
        ) : null}
      </div>
      <Footer />
    </React.Fragment>
  );
}
export default withRouter(Login);
